import { Martini } from 'lucide-react';
import { MarketingHeroPill } from '@/components/marketing/v2/MarketingHeroPill';
import { NeobrutalButton } from '@/components/marketing/v2/NeobrutalButton';

export default function BarHeroV2() {
  return (
    <section className="bg-paper pb-14 pt-16 md:pb-20 md:pt-20">
      <div className="mx-auto max-w-7xl px-6 md:px-8">
        <div className="grid items-center gap-12 md:grid-cols-[1.1fr_1fr] md:gap-14">
          {/* LEFT */}
          <div>
            <MarketingHeroPill dotColor="terracotta">
              Module premium · façon WISK
            </MarketingHeroPill>

            <h1 className="mt-7 font-marketing-display text-[clamp(42px,6.2vw,96px)] font-bold leading-[0.92] tracking-[-0.045em] text-charcoal-800">
              Maîtrise le coût réel
              <br />
              de <span className="underline-lime">chaque verre.</span>
            </h1>

            <p className="mt-7 max-w-xl font-marketing-body text-lg leading-[1.55] text-charcoal-600 md:text-xl">
              Velko Bar transforme chaque vente en consommation d'ingrédients. Tu vois le coût exact
              d'un cocktail, tu repères le surdosage, le coulage et le vol — en millilitres et en
              francs CFA.
            </p>

            <div className="mt-9 flex flex-wrap items-center gap-4">
              <NeobrutalButton as="link" to="/register" variant="primary" size="lg">
                Activer Velko Bar
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <path d="M5 12h14" />
                  <path d="M13 6l6 6-6 6" />
                </svg>
              </NeobrutalButton>
              <NeobrutalButton as="link" to="/tarifs" variant="secondary" size="lg">
                Voir les tarifs
              </NeobrutalButton>
            </div>
          </div>

          {/* RIGHT — pour-cost demo card */}
          <aside className="border-[3px] border-charcoal-800 bg-charcoal-800 p-7 text-white shadow-neobrutal-lime-10 md:p-8">
            <div className="flex items-center justify-between border-b border-charcoal-700 pb-4">
              <span className="inline-flex items-center gap-2 font-marketing-mono text-[11px] font-medium uppercase tracking-[0.12em] text-charcoal-200">
                <Martini className="h-4 w-4 text-lime-500" strokeWidth={2} />
                Recette · Mojito
              </span>
              <span className="font-marketing-mono text-[10px] uppercase tracking-[0.1em] text-lime-500">
                Pour cost 19%
              </span>
            </div>

            <ul className="mt-5 space-y-2.5">
              {[
                { name: 'Rhum blanc', qty: '50 ml', cost: '571 F' },
                { name: 'Jus de citron vert', qty: '30 ml', cost: '90 F' },
                { name: 'Sucre de canne', qty: '20 ml', cost: '40 F' },
                { name: 'Menthe · soda', qty: '—', cost: '120 F' },
              ].map((row) => (
                <li
                  key={row.name}
                  className="flex items-center justify-between gap-3 border-[1.5px] border-charcoal-700 px-3 py-2.5 font-marketing-body text-[13.5px]"
                >
                  <span className="text-charcoal-100">{row.name}</span>
                  <span className="font-marketing-mono text-[12px] text-charcoal-300">{row.qty}</span>
                  <span className="font-marketing-mono text-[12px] font-semibold text-lime-400">
                    {row.cost}
                  </span>
                </li>
              ))}
            </ul>

            <div className="mt-5 grid grid-cols-3 gap-2 border-t border-charcoal-700 pt-4 text-center">
              <div>
                <div className="font-marketing-mono text-[9px] uppercase tracking-[0.08em] text-charcoal-300">
                  Coût
                </div>
                <div className="mt-1 font-marketing-display text-[15px] font-bold text-white">821 F</div>
              </div>
              <div>
                <div className="font-marketing-mono text-[9px] uppercase tracking-[0.08em] text-charcoal-300">
                  Prix
                </div>
                <div className="mt-1 font-marketing-display text-[15px] font-bold text-white">
                  4 000 F
                </div>
              </div>
              <div>
                <div className="font-marketing-mono text-[9px] uppercase tracking-[0.08em] text-charcoal-300">
                  Marge
                </div>
                <div className="mt-1 font-marketing-display text-[15px] font-bold text-lime-500">
                  3 179 F
                </div>
              </div>
            </div>

            <div className="mt-4 flex items-center justify-between border-2 border-lime-500 bg-charcoal-900 px-3 py-2.5 font-marketing-mono text-[11px] uppercase tracking-[0.06em]">
              <span className="text-charcoal-200">Écart semaine · rhum</span>
              <span className="font-semibold text-terracotta-400">−150 ml · −1 714 F</span>
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}
